import React from "react";
import { useOrderStore } from "../../../store/useOrderStore.ts";

const RenderReviewButton = ({ review, status, entity }) => {
  const openCreateReview = useOrderStore((s) => s.openCreateReview);
  const openViewReview = useOrderStore((s) => s.openViewReview);

  if (!review) return null;

  if (review.has_review && status === "DELIVERED") {
    return (
      <button
        onClick={() => openViewReview(entity, review)}
        className="px-3 py-1 text-xs bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
      >
        مشاهده نظر
      </button>
    );
  }

  if (review.can_create && status === "DELIVERED") {
    return (
      <button
        onClick={() => openCreateReview(entity)}
        className="px-3 py-1 text-xs bg-blue-600 text-white rounded-lg hover:bg-blue-700"
      >
        ثبت نظر
      </button>
    );
  }

  if (status === "DELIVERED") {
    return (
      <button
        disabled
        className="px-3 py-1 text-xs bg-gray-200 text-gray-400 rounded-lg cursor-not-allowed"
      >
        پایان مهلت نظر
      </button>
    );
  }

  return (
    <button
      disabled
      className="px-3 py-1 text-xs bg-gray-200 text-gray-400 rounded-lg cursor-not-allowed"
    >
      ثبت نظر
    </button>
  );
};

export default RenderReviewButton;
